import "../../corpshaus2/site/assets/fonts/icons.eot"
import "../../corpshaus2/site/assets/fonts/icons.woff"
import "../../corpshaus2/site/assets/fonts/icons.woff2"
import "../../corpshaus2/site/assets/fonts/icons.ttf"
import "../../corpshaus2/site/assets/fonts/icons.svg"

import Vue, { DefineComponent, VueConstructor } from "vue"
import vuetify from "./initializers/vuetify"
import store from "./store"
import router from "./util/routes"
import "./initializers"
import { Portal } from "@linusborg/vue-simple-portal"
import PortalApp from "./components/Portal/PortalApp.vue"
import PortalAppPlain from "./components/Portal/PortalAppPlain.vue"
import AppContainer from "./components/AppContainer.vue"
import Memberlist from "./components/Memberlist.vue"
import Relations from "./components/Relations.vue"
import PeopleList from "./components/PeopleList.vue"
import ClientStats from "./components/ClientStats.vue"
import LevelStats from "./components/LevelStats.vue"
import AdminStats from "./components/AdminStats.vue"
import { i18n } from "./util/i18n"
import axios from "initializers/axios"
import ChangelogEntry from "features/changelog/ChangelogEntry.vue"
import BasicWysiwygEntry from "components/Wysiwyg/BasicWysiwygEntry.vue"
import LatestForumItems from "features/topics/LatestForumItems.vue"
import RSVPDashboardList from "app/modules/events/rsvp-dashboard/RSVPDashboardList.vue"

export { i18n }

// Used for loading indicators, don't remove (yet)
window.addEventListener("DOMContentLoaded", () => {
  axios.interceptors.request.use(
    (config) => {
      store.commit("loader/START_LOADING")
      return config
    },
    (error) => {
      store.commit("loader/FINISH_LOADING")
      return Promise.reject(error)
    }
  )

  axios.interceptors.response.use(
    (response) => {
      store.commit("loader/FINISH_LOADING")
      return response
    },
    (error) => {
      store.commit("loader/FINISH_LOADING")
      return Promise.reject(error)
    }
  )
})

// Is used for the Rails asset pipeline, don't remove
const images = require.context("./images", true)
//const imagePath = (name) => images(name, true)

/**
 * Register a Vue component to an element with the given ID.
 * The data attribute of the element will be passed as props to the component.
 * The data attribute should be a JSON string.
 *
 * Additional Vue options can be passed as the `use` parameter.
 *
 * A function can be passed as the `mapProps` parameter to transform the props before passing them to the component.
 *
 * @param elementId
 * @param component
 * @param use
 * @param mapProps
 */
const registerComponent = (
  elementId: string,
  component: VueConstructor | DefineComponent<any, any, any, any, any>,
  use?: any,
  mapProps?: (props: any) => any
) => {
  document.addEventListener("DOMContentLoaded", () => {
    const _mapProps = mapProps ?? ((props: any) => props)
    const element = document.getElementById(elementId)
    if (!element) return
    const props = _mapProps(JSON.parse(element.getAttribute("data") ?? null))
    new Vue({
      el: `#${elementId}`,
      render: (h) => h(component, { props }),
      components: { [component.name]: component },
      ...use,
    })
  })
}

const registerComponentByClass = (
  className: string,
  component: VueConstructor | DefineComponent<any, any, any, any, any>,
  use?: any,
  mapProps?: (props: any) => any
) => {
  document.addEventListener("DOMContentLoaded", () => {
    const _mapProps = mapProps ?? ((props: any) => props)
    const elements = document.getElementsByClassName(className)
    if (!elements) return
    Array.from(elements).forEach((element) => {
      const props = _mapProps(JSON.parse(element.getAttribute("data") ?? null))
      new Vue({
        el: element,
        render: (h) => h(component, { props }),
        components: { [component.name]: component },
        ...use,
      })
    })
  })
}

/**
 *  COMPONENT REGISTRATIONS
 */

registerComponentByClass("basic-wysiwyg", BasicWysiwygEntry, {
  vuetify,
})

registerComponent("memberlist", Memberlist, {
  router,
  store,
  i18n,
})

registerComponent("addRelation", Relations)

registerComponent("drive-container", AppContainer, {
  vuetify,
  router,
  store,
  i18n,
})

registerComponent("clientStats", ClientStats, {
  i18n,
})

registerComponent("levelStats", LevelStats, {
  i18n,
})

registerComponent("adminStats", AdminStats, {
  i18n,
})

registerComponent("peoplelist", PeopleList, {
  i18n,
})

registerComponent("latest-forum-items", LatestForumItems, {
  i18n,
  vuetify,
  store,
})

registerComponent("dashboard-rsvp-list", RSVPDashboardList, {
  i18n,
  vuetify,
  store,
})

registerComponent("app__vuetify", PortalApp, {
  router,
  store,
  vuetify,
  i18n,
  Portal,
})

registerComponent("app__vuetify--plain", PortalAppPlain, {
  router,
  store,
  vuetify,
  i18n,
  Portal,
})

registerComponent(
  "giftbox",
  ChangelogEntry,
  {
    vuetify,
    router,
  },
  (props) => ({ lastSeen: props.toString() })
)
